// extracted by mini-css-extract-plugin
export default {"tagGroup":"tag_tagGroup__hKLRs","tag":"tag_tag__qn6zo"};